<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UAqhZh/media/FC-9781035868148.jpg?1721600812019" alt="This image is the cover for the book Chance Beginning"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chance Beginning
      </h1>
      <p class="bookDescription body article font2">
        <p>The truth always finds a way. When you are the sole witness to a serious crime, what do you do? Do you turn a blind eye, or do you stand up for what is right and go to the authorities? But then again, what if the criminals are the authorities, and they are implicated in all areas of the judicial hierarchy? How do you keep yourself safe? Who can you trust? If you are Kiera Davidson, a legal assistant working for the DA, your gut instinct is to go to the police. Unfortunately, when the crime you’ve witnessed involves your boss, the risks are far greater. Stephen Douglas is up to his eyes in corruption and Kiera must find a way to ensure that he never finds out how much she knows. If he discovers what she has stumbled on to, Kiera realizes that she will be in grave danger. She must find a way to safeguard herself, and to make sure that Stephen doesn’t find a way of keeping her quiet; permanently.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cat Walker
      </h2>
      
      <p class="authorDescription body article">Cat Walker was born and raised in Minnesota, USA, where she first developed her love of creative writing. In 2006, she visited Ireland and fell in love, literally. She moved to Ireland in January 2007, and now lives in County Meath with her Ireland-born husband, and spends her time expanding her imagination and enjoying the beautiful Irish countryside.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b39702e